module.exports = __webpack_public_path__ + "resources/img/img_text_to_speech2_m.585bbd7b4e75ba9b8c0c57a6af692e3b.png";